<template>
  <ContractForm mode="update" :contract-id="$route.params.id" />
</template>

<script>
import ContractForm from './form.vue';

export default {
  name: 'ContractUpdate',
  components: { ContractForm },
};
</script>
